import React, {useState, useRef, useEffect} from 'react';
import LprInfringementAnalytics from './LprInfringementAnalytics';
import NoDataUpgradePrompt from '../../NoData';
import LprInfringementHeatmap from './infringementHeatmap';

const AnalyticsComponent = ({
  selectedSite,
  selectedCamera,
  selectedSuite,
  selectedYear,
  selectedCameraId = 'All'
}) => {

  const [isInfringementExpanded, setIsInfringementExpanded] = useState(true);

  const [hasInfringementData, setHasInfringementData] = useState(null);

  const prevCameraRef = useRef(selectedCameraId);
  const prevHwidRef = useRef(selectedSite.hwid);

  useEffect(() => {
    if (selectedCameraId !== prevCameraRef.current || selectedSite.hwid !== prevHwidRef.current) {
      setHasInfringementData(true);
      setIsInfringementExpanded(true);
      prevCameraRef.current = selectedCameraId;
      prevHwidRef.current = selectedSite.hwid;
    }
  }, [selectedCameraId, selectedSite.hwid]);

  const handleInfringementDataState = (hasData) => {
    // console.log("THE INFRINGEMENT SUITE HAS FOUND INFRINGEMENT DATA >>>>>>>>>>>>>>>>>>>>>>>>> ", hasData);
    setHasInfringementData(hasData);
  };

  return (

    <div className="graphs-container" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      {selectedSite && selectedCameraId && selectedSuite && (
        <>
          {/* <div style={{ width: '80%', margin: '20px 0', textAlign: 'center', position: 'relative', cursor: 'pointer' }}
            onClick={() => setIsInfringementExpanded(!isInfringementExpanded)}>
            <div style={{ display: 'inline-block', padding: '0 10px', fontWeight: 'bold', background: '#2B3441', position: 'relative', zIndex: 1, boxShadow: '0px 5px 15px rgba(255, 165, 0, 0.2)' }}>
              <span style={{ fontSize: '1.2em', color: 'white' }}>
                Infringement Analytics {isInfringementExpanded ? '▲' : '▼'}
              </span>
            </div>
            <div style={{ position: 'absolute', top: '50%', left: '0', right: '0', height: '1px', background: '#2B3441', boxShadow: '0px 5px 15px rgba(255, 165, 0, 0.2)', zIndex: 0 }} />
          </div> */}
          {(isInfringementExpanded && (hasInfringementData === true || hasInfringementData === null)) && (
            <div style={{ width: '90%' }}>
              <LprInfringementAnalytics
                hwid={selectedSite?.hwid}
                site={selectedSite?.site}
                selectedCamera={selectedCamera}
                selectedCameraId={selectedCameraId}
                selectedYear={selectedYear}
                handleInfringementDataState={handleInfringementDataState}  
              />
            </div>
          )}
          {hasInfringementData === false && (
            <div style={{ width: '90%' }}>
              <NoDataUpgradePrompt title="Lpr Infringement Analytics" />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AnalyticsComponent;